jQuery(document).ready(function() {

	// form word counter functions for word fields
	function wordCounter (e) {
		var maxwords = e.data('maxwords');
		var numwords = 0;
		if(e.val().length > 0) {
			numwords = e.val().split(/\s+/).length;
		}
		var plural = '';
		if (numwords > 1) {
			plural = 's';
		}
		e.siblings('.wordcounter').text(numwords+' word'+plural+' used out of of '+maxwords+' maximum');
		e.siblings('.messagefield').text('');
	}
	function initWordFields() {
		jQuery('.countwords').each(function() {
			var maxwords = jQuery(this).data("maxwords");
			if (!isNaN(maxwords) && typeof maxwords != "undefined") {
				var numwords = jQuery(this).val().split(/\s+/).length;
				jQuery(this).change(function() {
					wordCounter(jQuery(this));
				});
				jQuery(this).keyup(function() {
					wordCounter(jQuery(this));
				});
			}
		});
	}

	//General
	(function($) {

		$('.needs-validation').each(function() {
			$(this).submit(function(event) {
				if ($(this)[0].checkValidity() === false) {
					event.preventDefault();
					event.stopPropagation();

					$('html, body').animate({
						scrollTop: $('.form-control:invalid').first().offset().top - 200
					}, 1000);
				}
				$(this).addClass('was-validated');
			});
		});

		$('.cart-box .open-menu').click(function(){
			$('.mobile-menu').toggleClass('show');
			return false;
		});

		$('.checkbox-confirm').click(function(){
			$('.checkout-btn').toggleClass('hidden');
		});

		var nav_fixed = false;
		$(window).on("scroll", function(e) {
			var navbar = $("#header_nav");
			if ($(this).scrollTop() > 200) {
				if (!nav_fixed) {
					navbar.addClass("fix-nav");
					nav_fixed = true;
				}
			} else {
				if (nav_fixed) {
					navbar.removeClass("fix-nav");
					nav_fixed = false;
				}
			}

		});

		//Set the selected navigation item
		var found = false;
		$(".nav-menu .menu-item").each(function() {
			var nav_url = $(this).attr("data-url");
			if (nav_url != "/") {
				if (document.URL.search($(this).attr("data-url")) > -1) {
					$(this).addClass("current_page_item");
					found = true;
				}
			}
		});
		if (!found) {
			$(".nav-menu .menu-item").first().addClass("current_page_item");
		}

		//Header
		$("#menu_button").bind("click", function() {
			$(".full-header").toggleClass("show-menu");
			$(".nav-menu").toggleClass("show-menu");
		});

		var data = {
			action: "get_mini_cart"
		};

		$.get(GEXP.ajax_bypass, data, function(response) {
			var response = $.parseJSON(response);
			$("#mini_subtotal").html(parseFloat(response.cart_total).toFixed(2));
			$("#mini_quantity").html(response.cart_items);
		});

		//Footer newsletter signup
		$("#ge_email_friend_form").bind("submit", function(evt) {
			var data = $(this).serialize();
			data += "&action=sendfriendemail";
			data += "&permalink="+document.URL;
			$("#send_email_button").toggleClass("hidden");
			$(this).find(".loading").toggleClass("hidden");
			$.post(GEXP.ajaxurl, data, function(response) {
				$("#send_email_button").toggleClass("hidden");
				$("#ge_email_friend_form").find(".loading").toggleClass("hidden");
			});
			evt.preventDefault();
			return false;
		});

		//Footer

		initWordFields();

	})(jQuery);

	//Home page
	var ge_home_page = document.getElementById("ge_home_page");
	if (ge_home_page) {
		(function($) {
		})(jQuery);
	}


	//Terms and Conditions
	var ge_terms_page = document.getElementById("ge_terms_page");
	if (ge_terms_page) {
		(function($) {

			$(".terms-link").bind("click", function(e) {
				$("#ge_terms_sections a").removeClass("selected");
				$(this).addClass("selected");
				var anchor_id = $(this).attr('href');

				var position = $(anchor_id).offset().top - $(anchor_id).parent().offset().top - $(anchor_id).parent().scrollTop();

 				$("#terms_content").animate({ scrollTop: position }, 500);

				e.preventDefault();
				return false;
			});
		})(jQuery);
	}

	// Revival Gallery
	var ge_revival_gallery = document.getElementById("ge_revival_gallery");
	if (ge_revival_gallery) {
		(function($) {

			$(document).ready(function() {
				$('.galleryCollection').lightGallery({
					selector:'.thumb',
					useCss: false,
					autoplay: false,
					thumbnail: false,
					autoplayControls: false,
					fullScreen: false,
					zoom: false,
					download: false
				});

				$('#track-gallery').show();
				$('#track').addClass('active');


				$('.gallerySelect').click(function(){
					$('.galleryCollection').hide();
					$('.gallerySelect').removeClass('active');
					$('#'+$(this).attr('id')+'-gallery').show();
					$(this).addClass('active');
				});


			});

		})(jQuery);
	}

	//Car concourse
	var ge_concourse = document.getElementById("ge_concourse");
	if (ge_concourse) {
		(function($) {
			$(".profile-button").bind("click", function(evt) {
				$(".profile-button.activated").removeClass("activated");
				$(this).addClass("activated");

				$(".profile-content").addClass("hidden");
				$("."+$(this).attr("id")).removeClass("hidden");

				evt.preventDefault();
				return false;
			});

			var col_array = [
				$("#concourse_col_a"),
				$("#concourse_col_b")
			];
			resizeColumns(col_array);

		})(jQuery);
	}

	//Contact us
	var ge_contact_page = document.getElementById("ge_contact_page");
	if (ge_contact_page) {
		(function($) {

			var MyInfoWindow = new google.maps.InfoWindow();
			var markers=[];

			var track_map_height = $("#content_row").height()-70;
			$("#track_map").height(track_map_height+25);

			var trackMap;
			var trackMyInfoWindow = new google.maps.InfoWindow();
			var track_markers=[];

			var track_mapLat=track_location[0];
			var track_mapLng=track_location[1];
			var track_mapLatlng = new google.maps.LatLng(track_mapLat,track_mapLng);
			var track_mapOptions = {
				zoom: track_map_zoom,
				center: track_mapLatlng,
				mapTypeControl: false,
				navigationControl: true,
				navigationControlOptions: {
					style: google.maps.NavigationControlStyle.SMALL
				},
				mapTypeId: google.maps.MapTypeId.TERRAIN
			}
			trackMap = new GEMap("track_map");
			trackMap.init();
			var track_listener = google.maps.event.addListener(trackMap.map, "idle", function() {
				var marker = trackMap.setMarkerNoClick(new google.maps.LatLng(track_location[0], track_location[1]), true, " ", false);
				trackMap.map.setZoom(14);
			  	google.maps.event.removeListener(track_listener);
			});

		})(jQuery);
	}


	//Find us and hospitality and corporate
	var ge_find_us_page = document.getElementById("ge_find_us_page");
	var ge_hospitality_corporate_page = document.getElementById("ge_hospitality_corporate_page");
	if (ge_find_us_page || ge_hospitality_corporate_page){
		(function($) {

			var directionsDisplay = new google.maps.DirectionsRenderer();
			var directionsService = new google.maps.DirectionsService();

			var track_mapLat=track_location[0];
			var track_mapLng=track_location[1];
			var track_mapLatlng = new google.maps.LatLng(track_mapLat,track_mapLng);
			var mapOptions = {
				zoom: track_map_zoom,
				center: track_mapLatlng,
				mapTypeId: google.maps.MapTypeId.TERRAIN
			}

			var trackMap = new google.maps.Map(document.getElementById('ge_find_track_map'), mapOptions);

			directionsDisplay.setMap(trackMap);
			directionsDisplay.setPanel(document.getElementById('directions-panel'));

			var marker = new google.maps.Marker({
				position: track_mapLatlng,
				title:'test',
				map: trackMap,
			});

  			autocomplete = new google.maps.places.Autocomplete(document.getElementById('ge_find_track_origin'), {types:['geocode']});
			google.maps.event.addListener(autocomplete, 'place_changed', function() {
    			getRoute();
  			});

			function getRoute() {

				var output = '';
				var origin = jQuery('#ge_find_track_origin').val();
				var request = {
					origin: origin,
					destination: track_mapLatlng,
					travelMode: google.maps.TravelMode.DRIVING
				};
				directionsService.route(request, function(response, status){
					if (status == google.maps.DirectionsStatus.OK) {
						directionsDisplay.setDirections(response);
					}
					else {
						alert('Origin not found; please try again');
					}
				});
			}


		})(jQuery);
	}




	//Product videos
	var myVideo2 = document.getElementById("banner_video");
	if (!myVideo2 == ""){
		if (myVideo2.canPlayType) {
			myVideo2.onloadeddata=jQuery('#banner').css("display", "none"); jQuery('#videocontainer').css("display", "inline");
		}
	}

	//Checkout complete
	var ge_checkout_complete = document.getElementById("ge_checkout_complete");
	if (ge_checkout_complete) {
		(function($) {
			$("#ge_rewards_form").submit(function(e) {
				var pw = $("#rewards_pw").val();
				if (pw.length < 8) {
					alert("Your password must be at least 8 characters long");
					e.preventDefault();
					return false;
				} else {
					return true;
				}
			});
		})(jQuery);
	}

	//Shopping Basket
	//Shopping Cart
	var ge_cart = document.getElementById("ge_cart");
	if (ge_cart) {
		(function($) {

			$('.alert-remove-item').hide();
			$('.ge_remove_item').click(function() {
				var item_id = $(this).data('id');
				var quantity = 0;
				var data = {
					action: 'shoppingcart',
					cart_action: 'change_quantity',
					item_code: item_id,
					item_quantity: quantity,
					_wpnonce: GEXP.nonce
				};
				$.post(GEXP.ajaxurl, data, function(response) {
					var response = $.parseJSON(response);
					$('#ge_item_'+item_id).remove();
					refreshBasket(response);
					if (response.lines.length < 1) {
						$("#ge_checkout_bg").html('<div class="alert-empty-basket alert alert-danger" role="alert">Your shopping basket is empty. Visit <a href="/experiences/"> Experiences</a > or use the navigation above to book an experience or purchase a voucher.</div >');
						$("#ge_basket_footer").html("");
					}
				});
				$('.alert-remove-item').show();
				$('.alert-remove-item').addClass('show');
			});

			$(".ge_checkout_quantity").change(function() {
				var item_code = $(this).attr("id").split("_").slice(2);
				var quantity = $(this).val();
				var data = {
					action: 'shoppingcart',
					cart_action: 'change_quantity',
					item_code: item_code[0],
					item_quantity: quantity,
					_wpnonce: GEXP.nonce
				};

				$("#p_item_"+item_code).hide();
				$.post(GEXP.ajaxurl, data, function(response) {
					var response = $.parseJSON(response);

					for (var i=0; i < response.lines.length; i++) {
						$("#p_item_"+response.lines[i].item_id).html(GEXP.currency_symbol+response.lines[i].item_total_format.toFixed(2)).show();
					}
					if (quantity <= 0) {
						$("#ge_item_"+item_code[0]).remove();
						$(".ge_checkout_item[data-upgrade=\"" + item_code[0] + "\"]").remove();
						$('.alert-remove-item').show();
						$('.alert-remove-item').addClass('show');
					}
					if (response.lines.length < 1) {
						$("#ge_checkout_bg").html('<div class="alert-empty-basket alert alert-danger" role="alert">Your shopping basket is empty. Visit <a href="/experiences/"> Experiences</a > or use the navigation above to book an experience or purchase a voucher.</div >');
						$("#ge_basket_footer").html("");
					}

					refreshBasket(response);
				});


			});

			$(".ge_checkout_shipping").change(function() {
				var item_code = $(this).attr("id").split("_").slice(2);
				var method = $(this).val();
				var data = {
					action: 'shoppingcart',
					cart_action: 'change_delivery',
					item_code: item_code[0],
					item_postage: method,
					_wpnonce: GEXP.nonce
				};

				$.post(GEXP.ajaxurl, data, function(response) {
					var response = $.parseJSON(response);
					refreshBasket(response);
				});
			});

			$('.item-addon').change(function() {
				var item_id = $(this).data('item');
				var addon_id = $(this).data('addon');
				var status = $(this).is(':checked') ? 1 : 0;

				if ($(this).hasClass('item-addon-other')) {
					$('#'+addon_id+'_'+item_id).prop('checked', status);
				} else {
					$('#'+addon_id+'_'+item_id+'_other').prop('checked', status);
				}

				var data = {
					action: 'shoppingcart',
					cart_action: 'change_addon',
					item_id: item_id,
					addon_id: addon_id,
					status: status,
					_wpnonce: GEXP.nonce
				};

				$.post(GEXP.ajaxurl, data, function(response) {
					var response = $.parseJSON(response);
					refreshBasket(response);
				});
			});

			$('#ge_discount_code_submit').bind('click', function() {
				var code = $('#ge_discount_code').val();

				if (code != '') {
					var data = {
						action: 'shoppingcart',
						cart_action: 'add_discount',
						discount_code: code,
						_wpnonce: GEXP.nonce
					};

					$.post(GEXP.ajaxurl, data, function(response) {
						var response = $.parseJSON(response);

						var amount = parseFloat(response['discount_format']);
						refreshBasket(response);
						$('#ge_redeem_points').val(0);
						$('#ge_discount_code').val('');
						if (amount > 0) {
							$('#ge_discount_code_message').html('Your discount code has been applied');
						} else {
							$('#ge_discount_code_message').html('Please enter a valid discount code');
						}
					});
				} else {
					$('#ge_discount_code_message').html('Please enter a valid discount code');
				}

			});

			function refreshBasket(response) {
				$('#ge_checkout_subtotal').html(GEXP.currency_symbol+response.order_subtotal_format.toFixed(2));
				if (parseFloat(response.discount_format) > 0) {
					$('#ge_checkout_discount').html('-'+GEXP.currency_symbol+parseFloat(response.discount_format).toFixed(2));
					$('#ge_checkout_discount').parent().removeClass('d-none');
				} else {
					$('#ge_checkout_discount').parent().addClass('d-none');
				}
				for (var i = 0, len = response.cart_line_prices.length; i < len; i++) {
					var cart_line_price = response.cart_line_prices[i];
					$('.p_item_price_'+cart_line_price['item_id']).html(GEXP.currency_symbol+cart_line_price['price'].toFixed(2));
					$('.p_item_total_'+cart_line_price['item_id']).html(GEXP.currency_symbol+cart_line_price['total'].toFixed(2));
				}
				$('#ge_checkout_shipping').html(GEXP.currency_symbol+response.shipping_total.toFixed(2));
				$('#ge_checkout_total').html(GEXP.currency_symbol+response.order_total_format.toFixed(2));
				$('#mini_subtotal').html(response.order_subtotal_format.toFixed(2));
				$('#mini_quantity').html(response.cart_quantity);
			}

		})(jQuery);
	}

	//Checkout
	var ge_checkout = document.getElementById('ge_checkout');
	if (ge_checkout) {
		(function($) {
			var globalTimeout;
			var postcode_required = $('#billing_postcode').prop('required');

			function updateAddressFields(country_selector) {
				if (country_selector.hasClass('ge_delivery')) {
					var address_type = 'delivery';
				} else {
					var address_type = 'billing';
				}
				var county_box = $('#' + address_type + '_county_box');
				var state_box = $('#' + address_type + '_state_box');
				var postcode = $('#' + address_type + '_postcode');

				state_box.addClass('d-none');
				state_box.find('select').removeAttr('name');
				county_box.removeClass('d-none');
				county_box.find('input').attr('name', address_type + '_county');
				state_box.prop('required', false);
				postcode.prop('required', postcode_required);
				postcode.prop('placeholder', 'Postcode');
				switch (country_selector.val()) {
					case 'US':
						state_box.removeClass('d-none');
						state_box.find('select').attr('name', address_type + '_county');
						county_box.addClass('d-none');
						county_box.find('input').removeAttr('name');
						state_box.prop('required', true);
						postcode.prop('placeholder', 'Zip code');
						break;
					case 'IE':
						postcode.prop('required', false);
						break;
				}
			}

			$('#billing_country, #delivery_country').each(function() {
				updateAddressFields($(this));
			});

			$('#billing_country, #delivery_country').bind('change', function() {
				updateAddressFields($(this));
			});

			$('#has_shipping').bind('click', function(e) {
				if ($(this).prop('checked')) {
					$('#checkout-delivery h3').removeClass('disabled');
					$('#checkout-delivery input, #checkout-delivery select').prop('disabled', false);
				} else {
					$('#checkout-delivery h3').addClass('disabled');
					$('#checkout-delivery input, #checkout-delivery select').prop('disabled', true);
				}
			});

			$('.ge_voucher_message_te').bind('keyup', function(event) {
				var amount = $(this).val().length;
				var left = 200 - amount;
				var text = '';

				switch (left) {
					case 1:
						text = '1 character';
						break;
					case 0:
						text = '0 characters';
						break;
					default:
						text = left+' characters';
						break;
				}
				$('.'+$(this).attr('name')).html(text);
			});

			$('#cb_confirm').on('change', function() {
				$(this).removeClass('is-invalid');
			});

			var checkout_form = $('#ge_checkout_form');

			$('input.shipping_method', checkout_form).on('change', async function() {
				var billing_address = $('.billing_address');

				billing_address.addClass('d-none');

				$('input.shipping_method:checked', checkout_form).each(function() {
					if ($(this).val() != '99') {
						billing_address.removeClass('d-none');
					}
				});

				let reload = true;
				await Checkout.updateOrder(reload);
			});

			var is_v2 = $('.design-v2').length > 0;

			$('.payment-form').submit(async function(e) {

				if (is_v2) {
					e.preventDefault();

					var form = $(this);

					if (!checkout_form[0].checkValidity()) {
						e.stopPropagation();
						$(checkout_form).addClass('was-validated');
						$('html, body').animate({
							scrollTop: $('.form-control:invalid').first().offset().top - 200
						}, 1000);
						return;
					} else {
						let success = await Checkout.updateOrder();

						if (success) {
							if (form.attr('id') == 'stripe-submit-order') {
								stripe.redirectToCheckout({
									sessionId: $(this).data('session')
								});
							} else if (form.attr('id') != 'revolut-submit-order') {
								e.currentTarget.submit();
							}
						}
					}
				} else {
					var cb_confirm = $('#cb_confirm');
					if (cb_confirm.prop('checked')) {
						cb_confirm.removeClass('is-invalid');
						return true;
					} else {
						cb_confirm.addClass('is-invalid');
						return false;
					}
				}
			});

			$('#stripe-submit-order').submit(function (e) {
				e.preventDefault();

				if (!is_v2) {
					if ($('#cb_confirm').prop('checked')) {
						stripe.redirectToCheckout({
							sessionId: $(this).data('session')
						});
					}
				}
			});

			var form = $('#ge_checkout_form');
			var inputs = form.find('input.required-field, select.required-field');

			inputs.bind('keyup', validationBind);
			inputs.bind('change', validationBind);

			form.submit(function(e) {
				var inputs = form.find('input.required-field, select.required-field');
				var validation = updateInputStatus(inputs);
				if (validation['failed'].length > 0) {
					e.preventDefault();
					return false;
				} else {
					if (is_v2) {
						e.preventDefault();
						return false;
					} else {
						return true;
					}
				}
			});

			updateInputStatus(inputs);

			function validationBind() {
				if (globalTimeout != null) {
					clearTimeout(globalTimeout);
				}
				globalTimeout = setTimeout(function() {
					globalTimeout = null;
					var validation = updateInputStatus(inputs);
				}, 200);
			}

			$('#ge_discount_code_submit').bind('click', async function(e) {
				e.preventDefault();
				var code = $('#ge_discount_code').val();

				if (code != '') {
					var data = {
						action: 'shoppingcart',
						cart_action: 'add_discount',
						discount_code: code,
						_wpnonce: GEXP.nonce
					};

					await $.post(GEXP.ajaxurl, data, function(response) {
						var response = $.parseJSON(response);

						var amount = parseFloat(response['discount_format']);
						$('#ge_redeem_points').val(0);
						$('#ge_discount_code').val('');
						if (amount > 0) {
							$('#ge_discount_code_message').html('Your discount code has been applied');
							if (is_v2) {
								let reload = true;
								Checkout.updateOrder(reload);
							}
						} else {
							$('#ge_discount_code_message').html('Please enter a valid discount code');
						}
					});
				} else {
					$('#ge_discount_code_message').html('Please enter a valid discount code');
				}

			});

		})(jQuery);
	}

	//Activation Booking Complete
	var booking_complete = document.getElementById('ge_booking_complete');
	if (booking_complete) {
		addthisevent.refresh();
	}

	//Activation Availability Calendar
	var availability = document.getElementById('ge_act_booking');
	if (availability) {
		(function($) {

			var data = {
				'action': 'availability',
				'voucher_code': $('#voucher_code').val()
			};

			var slick_params = function() {
				return {
					'infinite': false,
					'slidesToShow': 5,
					'slidesToScroll': 5,
					'nextArrow': '<button class="slick-next-button">Later</button>',
					'prevArrow': '<button class="slick-prev-button">Earlier</button>',
					'responsive': [
						{
							'breakpoint': 1200,
							'settings': {
								'slidesToShow': 4,
								'slidesToScroll': 4
							}
						},
						{
							'breakpoint': 900,
							'settings': {
								'slidesToShow': 3,
								'slidesToScroll': 3
							}
						},
						{
							'breakpoint': 650,
							'settings': {
								'slidesToShow': 2,
								'slidesToScroll': 2
							}
						},
						{
							'breakpoint': 450,
							'settings': {
								'slidesToShow': 1,
								'slidesToScroll': 1
							}
						},
					]
				};
			};

			$('.availability-carousel').slick(slick_params());

			var mins = 15;
			var secs = (mins * 60) - 1;
			var currentSeconds = 0;
			var currentMinutes = 0;

			var event_obj = { 'id': '' };

			//Click booking slot event
			$('.book-hover').bind('click', clickBookingSlot);

			//Get more dates event
			$('.avail-button').bind('click', function(event) {
				if (!$(this).hasClass('disabled')) {
					$('.avail-button').removeClass('disabled');
					var reqdate, getnext;

					var isNext = $(this).hasClass('next-dates');
					if (isNext) {
						reqdate = $('.booking-req').last().html() + ' 23:59:59';
						getnext = true;
					}

					data.operation = 'get_availability';
					data.startdate = reqdate;
					data.getnext = getnext;

					$.post(GEXP.ajaxurl, data, function(response) {
						$('.featureLoading').hide();
						var response = $.parseJSON(response);
						if (response.has_dates) {
							$('#date-data').append(response.html);
						} else {
							$('#date-data').append('<p style="margin-bottom: 20px;">Sorry, no more future dates have been released for this event, please check back later or book one of the above dates.</p>');
						}

						$('.availability-carousel').not('.slick-initialized').slick(slick_params());

						if (!response.getmore) {
							if (isNext) {
								$('.next-dates').addClass('disabled');
							} else {
								$('.prev-dates').addClass('disabled');
							}
						}
						$('.book-hover').bind('click', clickBookingSlot);

						var aTag = $('.dates-wrapper').last();
					});
				}

			});

			function clickBookingSlot(event) {

				var proceed = true;

				if (proceed) {
					var slot = $(this).attr('title');
					var notice = $(this).data('notification');

					event_obj.id = $(this).attr('id').split('-')[1];
					event_obj.date = $(this).data('date');
					event_obj.time_block = $(this).data('time_block');

					$('body').block({'message': $('#question'), 'css': { 'width': '475px', 'border': 'none', 'background': 'none' }});

					$('#ge_selected_slot').html(slot);

					if (typeof notice != 'undefined' && notice) {
						$('#ge_booking_notice').show().html(notice);
					} else {
						$('#ge_booking_notice').html('').hide();
					}

					//Rebind events
					$('#ge_booking_yes').one('click', function() {
						$(this).unbind('click');
						$('body').unblock('body');
						$('#event_id').val(event_obj.id);
						$('#event_date').val(event_obj.date);
						$('#event_time_block').val(event_obj.time_block);
						$('#form_voucher').submit();
					});
					$('.ge_booking_no').one('click', function() {
						$('body').unblock('body');
					});
				}
			}

			function confirmBooking(eventid) {

				data.eid = eventid;
				data.operation = 'hold_booking';
				data._id = parms.sesh;
				jQuery('#booking_process').html('Please wait while we book your experience...');

				jQuery.post(GEXP.ajaxurl, data, function(response) {
					var response = jQuery.parseJSON(response);
					if (response.success) {
						jQuery('#booking_process').html(response.content);
						window.scrollTo(0, 0);
					} else {
						alert(response.message);
					}

				});
			}

		})(jQuery);
	}

	//Search page
	var ge_search = document.getElementById("ge_search");
	if (ge_search) {
		(function($) {
			var globalTimeout = null;
			var currentPage = 1;
			$(".ge-filter-controls input[type=text]").bind("keyup", function() {
				if (globalTimeout != null) {
					clearTimeout(globalTimeout);
				}
				globalTimeout = setTimeout(function() {
					globalTimeout = null;
					doSearch(false);
				}, 500);
			});

			//Get latlng by postcode from Google and then refresh the search
			$("#ge_postcode_search").bind("keyup", function() {
				var pc_input = $(this);
				var postcode = pc_input.val();

				if (globalTimeout != null) {
					clearTimeout(globalTimeout);
				}
				globalTimeout = setTimeout(function() {
					if (postcode) {
						globalTimeout = null;
						var data = {
							address: postcode+",+Scotland",
							sensor: false
						}
						$.get("https://maps.googleapis.com/maps/api/geocode/json", data, function(response) {
							if (response.status == "OK") {
								html = ['',
									'<li>',
										'<input autocomplete="off" class="custom-location" name="ge-location-filter" data-lat="'+response.results[0].geometry.location.lat+'" data-lng="'+response.results[0].geometry.location.lng+'" type="checkbox" value="'+postcode+'" checked />',
										'<label>'+postcode+'</label>',
									'</li>'
								].join('\n');
								$("#ge_location_options").prepend(html);
								pc_input.val("");
								$(".custom-location").unbind("change");
								$(".custom-location").bind("change", function() {
									doSearch(false);
								});
							}
							doSearch(false);
						});
					}
				}, 1500);

			});

			$(".ge-filter-controls select, .ge-filter-controls input[type=checkbox]").bind("change", function() {
				doSearch(false);
			});

			$("#search_loading").bind("inview", function (event, visible) {
				if (visible == true) {
					doSearch(true);
				}
			});

			function doSearch(scroll) {

				var search_term = $("#ge_search_term").val();
				var sorter = $("#ge_sort_options").val();
				sorter = sorter.split("-");

				if (scroll) {
					currentPage++;
				} else {
					currentPage = 1;
				}

				var chosen_terms = [];
				$("input[name=ge-subcat-filter]").each(function () {
					if (this.checked) {
						chosen_terms.push(parseInt(this.value));
					}
				});


				var price_filter = $("input[name=ge-price-filter]");
				var price_range = [];
				price_filter.each(function () {
					var min_price = parseInt($(this).data("min"));
					var max_price = parseInt($(this).data("max"));
					if (this.checked) {
						if (typeof price_range[0] == 'undefined' && typeof price_range[1] == 'undefined') {
							price_range[0] = min_price;
							price_range[1] = max_price;
						} else {
							if (price_range[0] > min_price) {
								price_range[0] = min_price;
							}
							if (price_range[1] < max_price) {
								price_range[1] = max_price;
							}
						}
					}
				});

				var location_filter = $("input[name=ge-location-filter]");
				var locations = [];
				location_filter.each(function () {
					if (this.checked) {
						locations.push([$(this).data("lat"), $(this).data("lng")]);
					}
				});

				var data = {
					action: 'products',
					operation: 'do_search',
					terms: chosen_terms,
					search_term: search_term,
					price_ranges: price_range,
					search_latlng: locations,
					order_key: sorter[0],
					order: sorter[1],
					spage: currentPage
				};

				$.get(GEXP.ajaxurl, data, function(response) {
					var results = $.parseJSON(response);
					if (results.results_found > 0) {
						$(".product-not-found").addClass("hidden").html("");
						var html = "";
						for (product in results["results"]) {
							html += ['',
								'<div class="product-listing">',
									'<div class="product-list-box">',
										'<a href="'+results["results"][product].permalink+'" title="'+results["results"][product].title+'"><img class="product-listing-thumbnail" src="'+results["results"][product]["thumbnails"][0].src+'" /></a>',
										(results["results"][product].exclusive?'<img class="exclusive-product" src="/wp-content/themes/giftexperience/images/exclusive.png" alt="Exclusive product" />':''),
										'<div class="product-list-text pwidth">',
											'<a href="'+results["results"][product].permalink+'" title="'+results["results"][product].title+'"><h3>'+results["results"][product].title+'</h3></a>',
											'<p>'+results["results"][product].description+'</p>',
											'<div class="product-location">',
												'<ul>',
													(results["results"][product].duration?'<li class="product-duration"><img src="/wp-content/themes/giftexperience/images/clock.png" /><span>'+results["results"][product].duration+'</span></li>':''),
													(results["results"][product].location?'<li><img src="/wp-content/themes/giftexperience/images/marker.png" /><span>'+results["results"][product].location+'</span></li>':''),
												'</ul>',
											'</div>',
											'<div class="product-price">',
												(results["results"][product].discounted?'<span class="ge-price oldprice">'+results["results"][product]["pre_discount_format"]+'</span> <span class="ge-price price">'+results["results"][product]	["price_format"]+'</span>':'<span class="ge-price price">'+results["results"][product]["price_format"]+'</span>'),
											'</div>',
										'</div>',
									'</div>',
								'</div>'
							].join('\n');
						}
						if (scroll) {
							$("#product_list_results").append(html);
						} else {
							$("#product_list_results").html(html);
						}
						if (results.results_found <= 15) {
							$("#search_loading").hide();
						} else {
							$("#search_loading").show();
						}
					} else {
						$("#search_loading").hide();
						if (!scroll) {
							$("#product_list_results").html("");
							$(".product-not-found").removeClass("hidden").html("Sorry, but we couldn't find any results for your search.");
						}
					}
					if (!scroll) {
						$("#search_term_used").html('"'+search_term+'"');
						$("#search_results_found").html(results.results_found+" Product"+(results.results_found!=1?"s":""));
					}
				});
			}

		})(jQuery);
	}

	//Product page
	var ge_product_page = document.getElementById('ge_product_page');
	if (ge_product_page) {
		(function($) {

			var is_v2 = $('.booking-flow-v2').length > 0;

			if (is_v2) {
				var slider = $('#booking-flow-slider');

				if ($('#age-selection:hidden').val() >= 0) {
					updateAvailability(1);
				}

				var dates = [];

				var time_blocks = ['Morning', 'Afternoon', 'Evening'];

				$('#item_quantity').bind('change', function() {
					updateAvailability($(this).val());
					slider.slick('slickGoTo', 0);
				});

				$('#age-selection').bind('change', function() {
					if ($(this).val() != '') {
						updateAvailability(1);
						$('#track-selection').removeAttr('disabled');
					} else {
						$('#track-selection').attr('disabled', 'disabled');
					}
					$('#track-selection .clearable-option').remove();
					$('#track-selection').trigger('change');
				});

				$('#track-selection').on('change', 'input', function() {
					$('#session-selection option.clearable-option').remove();
					if ($(this).val() != '') {
						var track = $(this).val();
						showDates(track);
						updateCars();
					} else {
						$('#session-selection').attr('disabled', 'disabled');
					}
				});

				$('#session-selection').bind('change', function() {
					if ($(this).val() != '') {
						$('#booking-flow #booking-flow-2 .step-title-wrap').trigger('click');
						updateCars();
						slider.slick('slickNext');
					}
				});

				function showDates(track) {
					var date_options = dates[track].toString().replace(',', '\n');
					$('#dates_label').after(date_options);
					$('#dates_label').prop('selected', true);
					$('#session-selection').removeAttr('disabled');
				}

				function updateAvailability(quantity) {
					dates = [];

					var data = {
						action: 'availability',
						operation: 'get_availability_product',
						quantity: quantity,
						pid: ge_product_id,
						age_id: $('#age-selection').val(),
						includes_premium_tracks: $('#booking-flow input[name=includes_premium_tracks]').val(),
						includes_weekends: $('#booking-flow input[name=includes_weekends]').val(),
						voucher_type: $('#booking-flow input[name=voucher_type]').val()
					};

					$.get(GEXP.ajaxurl, data, function(response) {
						var response = $.parseJSON(response);
						var tracks = '';
						$('select option.clearable-option').remove();
						if (response.length > 0) {
							$('#dates_error').addClass('d-none');
							for (var i=0; i < response.length; i++) {
								if (typeof dates[response[i].track_post_id] === 'undefined') {
									tracks += '<div class="col-6 col-lg-4 clearable-option"><label class="track-selection-wrap clearable-option"><input class="track-selection-check" type="radio" name="track-selection" value="'+response[i].track_post_id+'" data-premium_price="'+response[i].premium_price+'" data-item-name="'+response[i].track_name+'"><div class="track-selection-item"><div class="track-svg">'+response[i].track_svg+'</div><div class="track-content">'+response[i].track_name+'<br>'+response[i].region+'</div></div></label></div>';
									dates[response[i].track_post_id] = [];
								}
								var value = response[i].start_date;
								if (typeof response[i].time_block !== 'undefined') {
									value += ':'+response[i].time_block;
								}
								dates[response[i].track_post_id].push('<option class="clearable-option" value="'+value+'" data-premium_price="'+response[i].weekend_price+'">'+response[i].day+'</option>');
							}
						} else {
							$('#dates_error').removeClass('d-none');
							$('#track-selection').attr('disabled', 'disabled');
						}
						if ($('#track-selection').attr('type') == 'hidden') {
							track = $('#track-selection').val();
							showDates(track);
						} else {
							$('#track-selection').append(tracks);
						}
					});
				}

				function updateCars() {
					$('.car-box .time-block').addClass('sold-out');
					$('.car-box .car-selection-check').prop('disabled', true);
					$('.car-box .car-selection-check').prop('checked', false);
					$('.car-box .car-selection .fa').removeClass('fa-check-circle');
					$('.car-box .car-selection .fa').addClass('fa-times-circle');

					var data = {
						'action': 'availability',
						'operation': 'get_availability_cars',
						'track_id': $('#track-selection .track-selection-check:checked').val() || $('#track-selection').val(),
						'pid': ge_product_id,
						'age_id': $('#age-selection').val(),
						'date': $('#session-selection').val()
					};

					$.post(GEXP.ajaxurl, data, function(response) {
						var response = $.parseJSON(response);
						var has_evening = false;
						$('.time-block-2').hide();
						for (var i=0; i < response.length; i++) {
							var car = response[i];
							if (parseInt(car.available) == 1) {
								if (!has_evening && car.time_block == '2') {
									has_evening = true;
								}
								$('#car-box-'+car.car_post_id+' .time-block-'+car.time_block).removeClass('sold-out');
								$('#car-box-'+car.car_post_id+' .time-block-'+car.time_block+' .car-selection-check').prop('disabled', false);
								$('#car-box-'+car.car_post_id+' .time-block-'+car.time_block+' .car-selection span').html(time_blocks[car.time_block]);
								$('#car-box-'+car.car_post_id+' .time-block-'+car.time_block+' .car-selection .fa').addClass('fa-check-circle');
								$('#car-box-'+car.car_post_id+' .time-block-'+car.time_block+' .car-selection .fa').removeClass('fa-times-circle');
							}
						}
						if (has_evening) {
							$('.time-block-2').show();
						}
					});
				}
			} else {

				if ($('#age-selection:hidden').val() >= 0) {
					updateAvailability(1);
				}

				var dates = [];

				var time_blocks = ['Morning', 'Afternoon', 'Evening'];

				$('#item_quantity').bind('change', function() {
					updateAvailability($(this).val());
				});

				$('#age-selection').bind('change', function() {
					if ($(this).val() != '') {
						updateAvailability(1);
						$('#track-selection').removeAttr('disabled');
					} else {
						$('#track-selection').attr('disabled', 'disabled');
					}
					$('#track-selection option.clearable-option').remove();
					$('#track-selection').trigger('change');
				});

				$('#track-selection').bind('change', function() {
					$('#session-selection option.clearable-option').remove();
					if ($(this).val() != '') {
						var track = $(this).val();
						showDates(track);
						updateCars();
					} else {
						$('#session-selection').attr('disabled', 'disabled');
					}
				});

				$('#session-selection').bind('change', function() {
					if ($(this).val() != '') {
						$('#booking-flow #booking-flow-2 .step-title-wrap').trigger('click');
						updateCars();
					}
				});

				function showDates(track) {
					var date_options = dates[track].toString().replace(',', '\n');
					$('#dates_label').after(date_options);
					$('#dates_label').prop('selected', true);
					$('#session-selection').removeAttr('disabled');
				}

				function updateAvailability(quantity) {
					dates = [];

					var data = {
						action: 'availability',
						operation: 'get_availability_product',
						quantity: quantity,
						pid: ge_product_id,
						age_id: $('#age-selection').val(),
						includes_premium_tracks: $('#booking-flow input[name=includes_premium_tracks]').val(),
						includes_weekends: $('#booking-flow input[name=includes_weekends]').val(),
						voucher_type: $('#booking-flow input[name=voucher_type]').val()
					};

					$.get(GEXP.ajaxurl, data, function(response) {
						var response = $.parseJSON(response);
						var tracks = '';
						$('select option.clearable-option').remove();
						if (response.length > 0) {
							$('#dates_error').addClass('d-none');
							for (var i=0; i < response.length; i++) {
								if (typeof dates[response[i].track_post_id] === 'undefined') {
									tracks += '<option class="clearable-option" value="'+response[i].track_post_id+'" data-premium_price="'+response[i].premium_price+'">'+response[i].track_name+'</option>';
									dates[response[i].track_post_id] = [];
								}
								var value = response[i].start_date;
								if (typeof response[i].time_block !== 'undefined') {
									value += ':'+response[i].time_block;
								}
								dates[response[i].track_post_id].push('<option class="clearable-option" value="'+value+'" data-premium_price="'+response[i].weekend_price+'">'+response[i].day+'</option>');
							}
						} else {
							$('#dates_error').removeClass('d-none');
							$('#track-selection').attr('disabled', 'disabled');
						}
						if ($('#track-selection').attr('type') == 'hidden') {
							track = $('#track-selection').val();
							showDates(track);
						} else {
							$('#tracks_label').after(tracks);
						}
					});
				}

				function updateCars() {
					$('.car-box .time-block').addClass('sold-out');
					$('.car-box .car-selection-check').prop('disabled', true);
					$('.car-box .car-selection-check').prop('checked', false);
					$('.car-box .car-selection .fa').removeClass('fa-check-circle');
					$('.car-box .car-selection .fa').addClass('fa-times-circle');

					var data = {
						'action': 'availability',
						'operation': 'get_availability_cars',
						'track_id': $('#track-selection').val(),
						'pid': ge_product_id,
						'age_id': $('#age-selection').val(),
						'date': $('#session-selection').val()
					};

					$.post(GEXP.ajaxurl, data, function(response) {
						var response = $.parseJSON(response);
						var has_evening = false;
						$('.time-block-2').hide();
						for (var i=0; i < response.length; i++) {
							var car = response[i];
							if (parseInt(car.available) == 1) {
								if (!has_evening && car.time_block == '2') {
									has_evening = true;
								}
								$('#car-box-'+car.car_post_id+' .time-block-'+car.time_block).removeClass('sold-out');
								$('#car-box-'+car.car_post_id+' .time-block-'+car.time_block+' .car-selection-check').prop('disabled', false);
								$('#car-box-'+car.car_post_id+' .time-block-'+car.time_block+' .car-selection span').html(time_blocks[car.time_block]);
								$('#car-box-'+car.car_post_id+' .time-block-'+car.time_block+' .car-selection .fa').addClass('fa-check-circle');
								$('#car-box-'+car.car_post_id+' .time-block-'+car.time_block+' .car-selection .fa').removeClass('fa-times-circle');
							}
						}
						if (has_evening) {
							$('.time-block-2').show();
						}
					});
				}
			}

		})(jQuery);
	}


	var ge_event_calendar = document.getElementById("ge_event_calendar");
	if (ge_event_calendar) {
		(function($) {
			$("#ge-event-day-filter").bind("change", function(){
			var day = $(this).val();
			var days = $('.cal-days');
			var results = 0;
			days.addClass('hidden');
			days.each(function() {
				var event_day = $(this).data('day');
				if (day === event_day) {
					$(this).removeClass('hidden');
					++results;
				}
			});
			if (results > 0) {
				$(".product-not-found").addClass("hidden").html("");
			} else {
				$(".product-not-found").removeClass("hidden").html("Sorry, but we couldn't find any results for your search.");
			}
		});
	})(jQuery);
	}


	//Product listings
	var ge_product_listing = document.getElementById("ge_product_listing");
	if (ge_product_listing) {
		(function($) {

			$(".ge-filter-controls select").bind("change", function() {
				var product_box = $(".product-list-container"),
					products = $(".product-listing");

				var sort_order = this.value;

				products.sort(function(a,b){
					var an = a.getAttribute("data-price"),
						bn = b.getAttribute("data-price");

					if (sort_order == "price-asc") {
						return (an - bn);
					} else {
						return (bn - an);
					}

				});

				products.detach().appendTo(product_box);
			});



			$(".ge-filter-controls input").bind("click", function() {
				var chosen_terms = [];
				var category_filter_used = false;
				var container = $(".product-listing");
				var results = 0;
				container.addClass("hidden");
				$("input[name=ge-subcat-filter]").each(function () {
					if (this.checked) {
						chosen_terms.push(parseInt(this.value));
						category_filter_used = true;
					}
				});


				container.each(function() {

					var category = $(this).data("category");
					if (typeof category === 'string') {
						category = category.split(", ");
					}

					var category_match = -1;
					$(category).each(function(index, value) {
						if (category_match == -1) {
							category_match = $.inArray(parseInt(value), chosen_terms);
						}

					});
					if (!category_filter_used) {
						category_match = 1;
					}

					if (category_match > -1 ) {
						$(this).removeClass("hidden");
						results++;
					}

				});
				if (results > 0) {
					$(".product-not-found").addClass("hidden").html("");
				} else {
					$(".product-not-found").removeClass("hidden").html("Sorry, but we couldn't find any results for your search.");
				}

			});


		})(jQuery);
	}



});

/* Creates a googlemaps instance and provides methods for generating routes */
function GEMap(mapID) {
	this.map = false;
	this.mapID = mapID;
	this.route = [];
	this.routeLine =new google.maps.Polyline();
	this.bounds = new google.maps.LatLngBounds();
	this.infoWindow = new google.maps.InfoWindow();
	this.directionsDisplay = new google.maps.DirectionsRenderer({ draggable : false, hideRouteList: true, markerOptions: { visible: false } });
	this.directionsService = new google.maps.DirectionsService();
}

//Methods
GEMap.prototype.init = function() {

	var isDraggable = jQuery(document).width() > 480 ? true : false;
	try {
		var options = {
			zoom: 7,
			center: new google.maps.LatLng(56.929382,-3.746338),
			disableDefaultUI: true,
			draggable: isDraggable,
			zoomControl: true,
			zoomControlOptions: {
			  style: google.maps.ZoomControlStyle.MEDIUM,
			  position: google.maps.ControlPosition.TOP_RIGHT
			},
			mapTypeId: 'terrain'
		}

		//Extend the Google Maps API with some useful functions
		var that = this;


		google.maps.Map.prototype.markers = new Array();
		google.maps.Map.prototype.getMarkers = function() {
			return this.markers
		};
		google.maps.Map.prototype.clearMarker = function(index) {
			this.markers[index].setMap(null);
			this.markers.splice(index);
		};
		google.maps.Map.prototype.clearMarkers = function() {
			for(var i=0; i<this.markers.length; i++){
				this.markers[i].setMap(null);
			}
			this.markers = new Array();
		};
		//Create loading screen
		jQuery("#"+this.mapID).before("<div class=\"map_loading\"><h2>LOADING ...</h2></div>");

		//Load map
		this.map = new google.maps.Map(document.getElementById(this.mapID),options);
		google.maps.event.addListener(this.map, 'tilesloaded', function(){
	   		jQuery(".map_loading").fadeOut();
		});


		//Fit the map to the bounds of our experiences
		google.maps.event.addDomListener(window, 'resize', function() {
			that.map.fitBounds(that.bounds);
		});
	} catch (e) {
		alert("Unable to load GoogleMaps");
	}

}

google.maps.Marker.prototype._setMap = google.maps.Marker.prototype.setMap;

google.maps.Marker.prototype.setMap = function(map) {
	if (map) {
		if (typeof map.markers !== 'undefined') {
	    	map.markers[map.markers.length] = this;
		}
	}
	this._setMap(map);
}

GEMap.prototype.setCenterWithOffset= function(latlng, offsetX, offsetY) {
	var map = this.map;
	var ov = new google.maps.OverlayView();
	ov.onAdd = function() {
	    var proj = this.getProjection();
	    var aPoint = proj.fromLatLngToContainerPixel(latlng);
	    aPoint.x = aPoint.x+offsetX;
	    aPoint.y = aPoint.y+offsetY;
	    map.setCenter(proj.fromContainerPixelToLatLng(aPoint));
	};
	ov.draw = function() {};
	ov.setMap(map);
};

GEMap.prototype.getLocationByPostcode = function(postcode, callback) {

	var geocoder = new google.maps.Geocoder();
	geocoder.geocode({'address': postcode}, function postcodesearch(results, status) {
		if (status == google.maps.GeocoderStatus.OK) {
			var lat = results[0].geometry.location.lat();
			var lng = results[0].geometry.location.lng();
			var latlng = new google.maps.LatLng(lat, lng);
			callback(latlng);
		}
		else {
			alert("Unable to find location");
		}
	});
}

GEMap.prototype.setMarkerNoClick = function(location, visible, content, draggable, icon_url) {

	var marker = new google.maps.Marker({
		position: location,
		map: this.map,
		draggable: draggable,
		visible: visible,
		icon: icon_url
	});

	var that = this;

	this.bounds.extend(location);
	var i = this.map.markers.length-1;
	this.map.fitBounds(this.bounds);

	return marker;

}

GEMap.prototype.setMarker = function(location, visible, content, draggable, icon_url) {

	var marker = new google.maps.Marker({
		position: location,
		map: this.map,
		draggable: draggable,
		visible: visible,
		icon: icon_url
	});



	var that = this;
	google.maps.event.addListener(marker, 'click', function() {
		that.infoWindow.setContent(content);
		that.infoWindow.open(that.map,marker);
	});
	this.bounds.extend(location);
	var i = this.map.markers.length-1;
	this.map.fitBounds(this.bounds);

	return marker;

}

function updateInputStatus(inputs) {
	var validation = validateInputs(inputs);
	for (var i=0; i < validation["failed"].length; i++) {
		jQuery("."+validation["failed"][i]).removeClass("required-status-complete").addClass("required-status-pending");
	}

	for (var i=0; i < validation["passed"].length; i++) {
		jQuery("."+validation["passed"][i]).removeClass("required-status-pending").addClass("required-status-complete");
	}
	return validation;
}


function validateInputs(inputs) {

	var results = [];
	results["passed"] = [];
	results["failed"] = [];


	inputs.not('.ignore').each(function() {
		var element_id = jQuery(this).attr("id");
		var i = jQuery(this).val();
		if (jQuery(this).is(":visible")) {
			var type = jQuery(this).data("validate");
			var minlength = jQuery(this).data("minlength");
			var confirm_field = jQuery(this).data("confirm");
			var required = jQuery(this).hasClass('required-field');
			var messagefield = jQuery(this).siblings('.messagefield')
			messagefield.text(''); // reset error message for field
			if (i.length > 0 || required) {
				if (i.match(/^\s*$/) && typeof type != "undefined") {
					results["failed"].push(element_id);
				} else {
					if (typeof confirm_field != "undefined") {
						if (i != jQuery('#'+confirm_field).val()) {
							results["failed"].push(element_id);
							results["failed"].push(confirm_field);
						} else {
							results["passed"].push(element_id);
							results["passed"].push(confirm_field);
						}
					}
					if (!isNaN(minlength) && typeof minlength != "undefined") {
						if (i.length < minlength) {
							results["failed"].push(element_id);
						} else {
							results["passed"].push(element_id);
						}
					}
					switch(type) {
						case "words":
							var maxwords = jQuery(this).data("maxwords");
							var minwords = jQuery(this).data("minwords");
							var numwords = i.split(/\s+/).length;
							if (!isNaN(maxwords) && typeof maxwords != "undefined") {
								if (numwords > maxwords) {
									results["failed"].push(element_id);
									messagefield.text('Too many words - you currently have '+numwords+', please reduce to '+maxwords+' or fewer');
								} else {
									results["passed"].push(element_id);
								}
							}
							if (!isNaN(minwords) && typeof minwords != "undefined") {
								if (numwords < minwords) {
									results["failed"].push(element_id);
									messagefield.text('Too few words - you currently have '+numwords+', please increase to '+minwords+' or more');
								} else {
									results["passed"].push(element_id);
								}
							}
							break;
						case "numeric":
							if (isNaN(i)) {
								results["failed"].push(element_id);
							} else {
								results["passed"].push(element_id);
							}
							break;
						case "phone":
							re = /^[\d()+ ]+$/;
							if (!re.test(i)) {
								results["failed"].push(element_id);
							} else {
								results["passed"].push(element_id);
							}
							break;
						case "email":
							re = /\S+@\S+\.\S+/;
							if (!re.test(i)) {
								results["failed"].push(element_id);
							} else {
								results["passed"].push(element_id);
							}
							break;
						case "textarea":
							if (i.match(/^\s*$/)) {
								results["failed"].push(element_id);
							} else {
								results["passed"].push(element_id);
							}
							break;
						case "checkbox":
							if (!jQuery(this).is(':checked')) {
								results["failed"].push(element_id);
							} else {
								results["passed"].push(element_id);
							}
							break;
						case "select":
							if (!jQuery(this).val() != "") {
								results["failed"].push(element_id);
							} else {
								results["passed"].push(element_id);
							}
							break;
						default:
							results["passed"].push(element_id);
					}
				}
			}
		}
		else if (jQuery(this).data("validate") == 'sortcode') {
			if (i.match(/^\s*$/) || isNaN(i) || i.length < 6) {
				results["failed"].push(element_id);
			} else {
				results["passed"].push(element_id);
			}
		}
	});

	return results;
}

function resizeColumns(col_array) {

	var tallest_index=0;
	var tallest_value=0;

	for (var i=0; i < col_array.length; i++) {
		col_array[i].css("height","");

		var height = col_array[i].height();

		if (height > tallest_value) {
			tallest_index = i;
			tallest_value = height;
		}
	}

	for (var i=0; i < col_array.length; i++) {
		var padding = parseInt(col_array[i].css("padding-top").replace("px", "")) + parseInt(col_array[i].css("padding-bottom").replace("px", ""));
		col_array[i].height(tallest_value - padding);
	}
}

const Checkout = (($) => {

	let checkout_form = $('#ge_checkout_form');

	async function updateOrder(reload) {
		return new Promise((resolve) => {
			reload = reload || false;

			$('#order-update-error').addClass('d-none');

			var ref = $('input[name="ref"]', checkout_form).val();
			var billing_email = $('input[name="billing_email"]', checkout_form).val();
			var billing_forename = $('input[name="billing_forename"]', checkout_form).val();
			var billing_surname = $('input[name="billing_surname"]', checkout_form).val();
			var billing_telephone = $('input[name="billing_telephone"]', checkout_form).val();
			var mailing_list = $('input[name="mailing_list"]:checked', checkout_form).val();
			var item_details = {};
			$('[name^="item_details_"]').each(function() {
				let value = '';
				if ($(this).attr('type') == 'radio') {
					if ($(this)[0].checked) {
						item_details[$(this).attr('name')] = $(this).val();
					}
				} else {
					item_details[$(this).attr('name')] = $(this).val();
				}
			});

			var data = {
				action: 'checkout',
				operation: 'update_order',
				ref: ref,
				billing_email: billing_email,
				billing_forename: billing_forename,
				billing_surname: billing_surname,
				billing_telephone: billing_telephone,
				item_details: item_details,
				mailing_list: mailing_list,
				_wpnonce: GEXP.nonce
			};

			let has_shipping = false;
			$('input.shipping_method', checkout_form).each(function() {
				if ($(this).val() != '99') {
					has_shipping = true;
				}
			});

			if (has_shipping) {
				data.billing_address1 = $('input[name="billing_address1"]', checkout_form).val();
				data.billing_address2 = $('input[name="billing_address2"]', checkout_form).val();
				data.billing_town = $('input[name="billing_town"]', checkout_form).val();
				data.billing_county = $('input[name="billing_county"]', checkout_form).val();
				data.billing_state = $('input[name="billing_state"]', checkout_form).find(':selected').val();
				data.billing_postcode = $('input[name="billing_postcode"]', checkout_form).val();
				data.billing_country = $('select[name="billing_country"]', checkout_form).find(':selected').val();
			}

			$.post(GEXP.ajaxurl, data)
				.done(function(raw) {

					let response;

					try {
						response = JSON.parse(raw);
					} catch {
						Checkout.showError();
                        return resolve(false);
					}

					if (reload) {
						window.location.reload();
					}

					if (response.success) {
						resolve(true);
					} else {
						let message = '';
						if (response.message) {
							message += response.message + '<br>';
						}
						if (response.errors) {
							for (var i=0; i < response.errors.length; i++) {
								message += response.errors[i] + '<br>';
							}
						}
						Checkout.showError(message);
						resolve(false);
					}
				})
				.fail(function() {
                    Checkout.showError();
                    resolve(false);
                });
		});
	}

	function showError(message) {
		let error_message = '<strong>There was an error!</strong><br>';
		if (message) {
			error_message += message;
		} else {
			error_message += '<br>Please try again.';
		}
		$('input', checkout_form).on('change input', function(e) {
			$('#order-update-error').addClass('d-none');
		});
		$('#order-update-error').removeClass('d-none');
		$('#order-update-error').html(error_message);
	}

    return {
        updateOrder,
		showError
    };
})(jQuery);
